export type SupportedLocale = 'en-AU' | 'fr-FR' | 'de-DE'
export const DEFAULT_LOCALE: SupportedLocale = 'en-AU'
